import { handleActions } from 'redux-actions';
import { Map } from 'immutable';
import actions from '@synergycms_app/store/actions';

//REDUCERS
const availCacheActions = actions.availCache;
export default handleActions(
  {
    [availCacheActions.getAsync.toString()]: (avails, { payload }) => {
      return avails.merge(payload);
    },
  },
  Map()
);

//REDUCERS
//export default combineReducers({ hotel }, Record({ hotel: undefined }));
